import 'htmx.org'
import 'ninja-keys'

document.addEventListener('DOMContentLoaded', () => {
  const ninja = document.querySelector('#command-palette')
  if (!ninja) return

  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    ninja.classList.add('dark')
  }

  fetch('/command_palette')
    .then(r => r.json())
    .then(items => {
      ninja.data = items.map(item => ({
        id: item.id,
        title: item.title,
        section: item.section,
        parent: item.parent,
        keywords: item.keywords,
        handler: () => { window.location.href = item.url },
      }))
    })
})
